"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const ExperimentsContext = react_1.default.createContext({});
exports.default = ExperimentsContext;
//# sourceMappingURL=ExperimentsContext.js.map